import axios from 'axios';
import Service from './services/core/service';
export { V10, V11, V20, setup, withJWT, withBasicAuth, getJWT, getServicesBasicAuth, getDMSBasicAuth, getServicesUrl, getDmsUrl } from './setup';
export { axios };
export default Service;